/**
 * This file takes care of global app side effects,
 * like clicking on add to cart and the cart modal being displayed
 */

import { effect, signal } from "@preact/signals";

const displaySearchbar = signal(false);
const displayToast = signal("");
const displayQuickView = signal(false);

let timeout: number;

effect(() => {
  if (displayToast.value) {
    clearTimeout(timeout);
    timeout = setTimeout(() => displayToast.value = "", 4000);
  }
});

const state = {
  displaySearchbar,
  displayToast,
  displayQuickView,
};

export const useUI = () => state;
